import type { AssignmentFormValues } from 'pages/instructor/slide_deck/AssignmentDialog/schemas'
import type { UseFormSetValue } from 'react-hook-form'

export function setFinalGradeVisibility({
  setValue,
  showFinalGradeToParticipants,
}: {
  setValue: UseFormSetValue<AssignmentFormValues>
  showFinalGradeToParticipants: boolean
}) {
  setValue('showFinalGradeToParticipants', showFinalGradeToParticipants, {
    shouldDirty: true,
  })

  if (!showFinalGradeToParticipants) {
    setValue('gradeAppealsEnabled', false, { shouldDirty: true })
  }
}
